export default "__VITE_ASSET__BKlDDiIg__"